import { Component } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, EffectCoverflow, Pagination, } from "swiper";

// Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import teamPlayers from "../data/teamPlayers";

// Register Swiper modules 
SwiperCore.use([Autoplay, EffectCoverflow, Pagination]);

class PlayerSection extends Component {
  render() {
    return (
      <section className="player-section padding-top padding-bottom">
        <div className="container player-container">

          {/* ===== HEADER ===== */}
          <div className="section-header text-center">
            <p className="text-anim-fade-down js-animate delay-sm">
              Our Team Players
            </p>
            <h2 className="text-anim-typing js-animate delay-md">
              Meet Our Squad Players
            </h2>
          </div>

          {/* ===== SLIDER ===== */}
          <div className="section-wrapper">
            <Swiper
              effect="coverflow"
              grabCursor={true}
              centeredSlides={true}
              slidesPerView="auto"
              loop={true}
              speed={900}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              coverflowEffect={{
                rotate: 18,
                stretch: 0,
                depth: 220,
                modifier: 1,
                slideShadows: false,
              }}
              pagination={{ clickable: true }}
              className="playerCoverflow"
            >
              {teamPlayers.map((player, i) => (
                <SwiperSlide key={i}>
                  <div
                    className="player-item-2 text-center"
                    style={{
                      backgroundImage:
                        "url(/assets/images/team/player-bg.png)",
                    }}
                  >
                    <div className="player-inner-2">
                      <div className="player-thumb-2">
                        <Link to={`/team/${player.slug}`}>
                          <img src={player.image} alt={player.name} />
                        </Link>
                      </div>

                      <div className="player-content-2">
                        <Link to={`/team/${player.slug}`}>
                          <h2>F9 {player.name}</h2>
                          <p>{player.role}</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

        </div>
      </section>
    );
  }
}

export default PlayerSection;
